var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamingbolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.5 -0.5 48 37",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 48.00,0.00 C 47.91,6.37 42.37,3.56 36.00,11.00 36.00,11.00 41.00,9.00 41.00,9.00 37.65,16.00 33.36,17.25 26.00,16.96 22.18,16.81 16.45,14.92 13.32,17.60 9.58,20.79 12.30,26.16 16.04,26.26 18.89,26.33 20.46,23.97 22.00,22.00 22.00,22.00 16.00,23.00 16.00,23.00 18.63,15.50 22.42,21.87 33.00,18.00 33.00,18.00 27.00,28.00 27.00,28.00 27.00,28.00 31.00,26.00 31.00,26.00 29.62,29.02 28.65,31.25 25.90,33.35 22.67,35.81 18.92,36.16 15.00,35.96 -1.18,35.11 -3.35,14.05 9.02,7.69 11.23,6.54 13.52,6.10 16.00,6.05 19.53,5.99 20.88,6.55 24.00,8.00 24.00,8.00 21.00,12.00 21.00,12.00 21.00,12.00 33.00,4.45 33.00,4.45 33.00,4.45 48.00,0.00 48.00,0.00 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingbolt);
export default __webpack_public_path__ + "static/media/gamingbolt.410a2000aea2f6a102e311ce65fcca35.svg";
export { ForwardRef as ReactComponent };